import { formatDate } from "../../../../shared/i18n/index.js";

export function getNodeDateRange(node) {
  const start = parseDateOnly(node.startDate || node.endDate);
  const end = parseDateOnly(node.endDate || node.startDate);
  if (!start || !end) return null;
  const startDay = getDayNumber(start);
  const endDay = getDayNumber(end);
  return {
    startDay: Math.min(startDay, endDay),
    endDay: Math.max(startDay, endDay),
  };
}

export function formatDateRange(node) {
  if (node.startDate && node.endDate) return `${node.startDate} - ${node.endDate}`;
  return node.startDate || node.endDate || "";
}

export function parseDateOnly(value) {
  if (!value) return null;
  const text = String(value);
  const match = /^(\d{4})-(\d{2})-(\d{2})/.exec(text);
  const date = match
    ? new Date(Date.UTC(Number(match[1]), Number(match[2]) - 1, Number(match[3])))
    : new Date(value);
  if (Number.isNaN(date.getTime())) return null;
  return date;
}

export function getDayNumber(date) {
  return Math.floor(Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate()) / 86400000);
}

export function formatShortDate(value) {
  if (!value) return "";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "";
  // The app's language, not the browser's.
  return formatDate(date, { month: "short", day: "numeric" });
}

export function formatShortDateTime(value) {
  if (!value) return "";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "";
  return formatDate(date, {
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}

export function toDateInputValue(date) {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}
